export default __webpack_public_path__ + "static/media/activeGridView.f19c0b49.svg";